import { render, staticRenderFns } from "./DiscussionMessage.vue?vue&type=template&id=457cdae9&scoped=true"
import script from "./DiscussionMessage.vue?vue&type=script&lang=js"
export * from "./DiscussionMessage.vue?vue&type=script&lang=js"
import style0 from "./DiscussionMessage.vue?vue&type=style&index=0&id=457cdae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457cdae9",
  null
  
)

export default component.exports